/** Toolbar entries that trigger an action instead of applying a format. */
const TOOLBAR_ACTIONS = ['clean'];

/**
 * Derives the whitelist of formats a Quill instance should accept from its own
 * toolbar definition.
 *
 * Quill registers colour, background, font, size, align, indent and friends
 * regardless of which buttons are configured -- the toolbar only decides what
 * the user can click, not what the document accepts. So pasted content keeps
 * formats the editor never offered, and they end up stored. Passing the result
 * of this to `<quill-editor [formats]>` closes that gap.
 *
 * Deriving instead of hand-listing keeps the two in step: adding a toolbar
 * button can't leave behind a button that appears to do nothing because its
 * format wasn't whitelisted.
 */
export function quillFormatsFromToolbar(toolbar: unknown): string[] {
  const formats = new Set<string>();

  const visit = (entry: unknown): void => {
    if (Array.isArray(entry)) {
      entry.forEach(visit);
      return;
    }

    if (typeof entry === 'string') {
      if (!TOOLBAR_ACTIONS.includes(entry)) {
        formats.add(entry);
      }
      return;
    }

    // Dropdowns and value pickers arrive as { header: [...] }, { list: 'bullet' }.
    if (entry && typeof entry === 'object') {
      Object.keys(entry).forEach((key) => formats.add(key));
    }
  };

  visit(toolbar);

  return Array.from(formats);
}
